import $ from 'jquery';

function isTouchDevice() {
    // https://stackoverflow.com/a/4819886/3717467
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

$('.meta-nav__link--language').on('click', function (e) {
    //let $siblings = $(this).siblings('.lang-menu');
    //if (isTouchDevice() && !$siblings.hasClass('lang-menu--open')) {
    //    e.preventDefault();
    //    $siblings.addClass('lang-menu--open')
    //}
})

$(document).on('click', ev => {
    if (!isTouchDevice()) {
        return;
    }
    if ($(ev.target).closest('.meta-nav__item--language').length < 1) {
        $('.lang-menu').removeClass('lang-menu--open')
    }
});

$('.meta-nav__link--language, .lang-menu').on('mouseenter', function (e) {
    if(!isTouchDevice()) {
        $(this).siblings('.lang-menu').addClass('lang-menu--open')
    }
})

$('.meta-nav__link--language, .lang-menu').on('mouseleave', function (e) {
    if (!isTouchDevice() && $(e.relatedTarget).parents('.meta-nav__item--language').length < 1) {
        $('.lang-menu').removeClass('lang-menu--open')
    }
})
